const hy = {
  ourProjects: 'Մեր նախագծերը',
  usernameIsTaken: 'Username is already taken. Please try another one.',
  settingsTxt: 'Կարգավորումներ',
  myProfileTxt: ' Իմ պրոֆիլը',
  bobName: 'Bob - AI Assistant',
  awarenessTest: 'Awareness Test',
  findSolutions: 'Գտեք ձեր խնդիրների լուծումները',
  learnAboutUXCore: 'Սովորել մարդու մտածողության օրինաչափությունները',
  podcast: 'Պոդկաստ',
  arcOfSelf: 'Arc of Self',
  arcOfSelfTooltip: 'Ինքնության ռեկուրսիվ տեսություն',
  done: 'Done',
  usefulLinks: [
    {
      title: '',
      items: [
        {
          title: 'Կոգնիտիվ հակումները կրթության մեջ',
          link: '/articles/uxeducation',
        },
      ],
    },
    {
      title: 'UX CORE GUIDE',
      items: [
        {
          title: 'Ավելացրեք ձեր հարցը',
        },
      ],
    },
    {
      title: 'UX CORE PERSONA',
      items: [
        {
          title: 'Ներածական հոդված',
          icon: 'medium-logo',
          link: 'https://medium.com/@alexanyanwolf/creating-user-persona-with-cognitive-biases-and-ux-core-cb5a03a897a9',
          target: '_blank',
          alt: 'Medium.com publishing platform logo',
        },
      ],
    },
    {
      title: '',
      items: [
        {
          title: 'API',
          icon: 'api',
          link: '/uxcore-api',
          target: '',
          alt: 'UX Core API',
        },
      ],
    },
  ],
};

export default hy;
